import { ReactNode } from 'react';
import { Box, BoxProps } from '@mui/material';

interface PageShellProps extends Omit<BoxProps, 'maxWidth'> {
  children: ReactNode;
  maxWidth?: number | false;
}

export default function PageShell({ children, maxWidth = 1600, sx, ...props }: PageShellProps) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: maxWidth === false ? 'none' : maxWidth,
        mx: maxWidth === false ? 0 : 'auto',
        minWidth: 0,
        overflow: 'hidden',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
